import styled from "styled-components";
import {Link} from "../../../../../raw-components/link/link";

export const SearchLinkDefaultBox = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  ${({theme}) => theme.font.presets.regular};
  font-weight: 400;
  font-size: 1.5rem;
  white-space: pre;
  color: ${props => props.theme.colors.text};

  &:hover {
    color: ${props => props.theme.colors.textHover};
    background-color: ${props => props.theme.colors.backgroundHover};
  }

  &:before {
    content: "";
    width: 25px;
    height: 25px;
    margin: 0 0.5rem 0 0;
    background-image: url("${props => props.theme.assets.images.SpriteSheetPC1920_png.toString()}");

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      transform: scale(0.8);
    }
  }
`;